var map = {
	"./plug-icon-3001.png": 253,
	"./plug-icon-3002.png": 254,
	"./plug-icon-3003.png": 255,
	"./plug-icon-3004.png": 256,
	"./plug-icon-3005.png": 257,
	"./plug-icon-3006.png": 258,
	"./plug-icon-4001.png": 259,
	"./plug-icon-water.png": 165
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 609;